import { render, staticRenderFns } from "./downloadRelativeFile.vue?vue&type=template&id=6bd14fad&scoped=true&"
import script from "./downloadRelativeFile.vue?vue&type=script&lang=js&"
export * from "./downloadRelativeFile.vue?vue&type=script&lang=js&"
import style0 from "./downloadRelativeFile.vue?vue&type=style&index=0&id=6bd14fad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd14fad",
  null
  
)

export default component.exports